import {flow, getSnapshot, Instance, types} from 'mobx-state-tree';
import {IComponent, ILumpComponent, IPureComponent} from '@progress-fe/core';
import {ResetModel} from 'core/models';

import {
  ModelsCatalog,
  ElementsCatalog,
  PureComponentsCatalog,
  LumpComponentsCatalog
} from './models';

const CatalogsStore = types
  .compose(
    ResetModel,
    types.model('CatalogsStore', {
      modelsCatalog: types.optional(ModelsCatalog, {}),
      elementsCatalog: types.optional(ElementsCatalog, {}),
      pureComponentsCatalog: types.optional(PureComponentsCatalog, {}),
      lumpComponentsCatalog: types.optional(LumpComponentsCatalog, {})
    })
  )
  .actions((self) => ({
    load: flow(function* () {
      yield Promise.allSettled([
        self.modelsCatalog.load(),
        self.elementsCatalog.load(),
        self.pureComponentsCatalog.load(),
        self.lumpComponentsCatalog.load()
      ]);
    })
  }))
  .views((self) => ({
    get pureComponents(): IPureComponent[] {
      return getSnapshot(self.pureComponentsCatalog.components);
    },
    get lumpComponents(): ILumpComponent[] {
      return getSnapshot(self.lumpComponentsCatalog.components);
    }
  }))
  .views((self) => ({
    get componentsDictionary(): Record<string, IComponent> {
      return [...self.pureComponents, ...self.lumpComponents].reduce(
        (acc: Record<string, IComponent>, cur: IComponent) => {
          acc[cur.uuid] = cur;
          return acc;
        },
        {}
      );
    }
  }));

export type TCatalogsStoreModel = Instance<typeof CatalogsStore>;

export {CatalogsStore};
